import { SkeletonRows } from '@patchbay/ui'
import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'
import { AdminAutomation, AdminFeatureFlags, AdminSettings } from '../features/admin'
import { automationQuery, currentUserQuery, featureFlagsQuery, settingsQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'
import { SettingGuard } from '../features/admin/setting-guard'

export const Route = createFileRoute('/admin/settings')({
  ...adminRouteState,
  loader: ({ context }) => {
    // The scoreboard must not blank Settings. Prefetch it; the panel shows its own failure (#626).
    void context.queryClient.prefetchQuery(automationQuery()).catch(() => undefined)
    return Promise.all([
      context.queryClient.ensureQueryData(settingsQuery()),
      context.queryClient.ensureQueryData(featureFlagsQuery()),
      context.queryClient.ensureQueryData(currentUserQuery()),
    ])
  },
  // Automation (#233) leads: the automatic senders are the settings people come looking for.
  component: function AdminSettingsRoute() {
    return (
      <div className="max-w-5xl space-y-6">
        <SettingGuard label="Automation" detail="The autonomy ladder could not be loaded. The settings below are unchanged.">
          <Suspense fallback={<SkeletonRows count={4} />}>
            <AdminAutomation />
          </Suspense>
        </SettingGuard>
        <SettingGuard label="Feature flags & rollout" detail="Runtime flags could not be loaded. No value was changed.">
          <Suspense fallback={<SkeletonRows count={5} />}>
            <AdminFeatureFlags />
          </Suspense>
        </SettingGuard>
        <AdminSettings />
      </div>
    )
  },
})
